import { render, staticRenderFns } from "./MerchantCategoryTreeSelect.vue?vue&type=template&id=4adb6aad"
import script from "./MerchantCategoryTreeSelect.vue?vue&type=script&lang=js"
export * from "./MerchantCategoryTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports